import fetch from 'isomorphic-fetch';

export const updateVerifyEmailErrorMessage = (message) => (dispatch) => {
  dispatch({
    type: 'UPDATE_VERIFY_EMAIL_ERROR_MESSAGE',
    message,
  });
};

export const verifyToken = (token, successRedirect = null) => (dispatch) => {
  fetch('/auth/local/verify-email', {
    credentials: 'include',
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      data: {
        attributes: {
          token,
          successRedirect,
        },
      },
    }),
  })
    .then((res) => res.json())
    .then((data) => {
      if (data.errors) {
        dispatch(updateVerifyEmailErrorMessage(data.errors[0].code));
        window.location = `${process.env.UNICAT_ACCOUNTS_SERVICE}/invalid-link`;
      } else {
        window.location.href = data.location;
      }
    })
    .catch((e) => {
      console.log(e);
    });
};



// WEBPACK FOOTER //
// ./action-creators/verifyEmail.js